
import React from 'react';
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import Navbar from '../commonComponents/Navbar';
import Footer from '../commonComponents/Footer';
// import '../Pages/TermsAndCondition.css';

import './TermsAndCondition.css';

const TermsAndConditions = () => {
  return (
    <>
      <Navbar />
      <div className="container terms-container mt-5 pt-md-5 mb-5">
      <h1 className="text-center headings mt-md-5">
        <span>Blueberry Travel</span> - Terms and Conditions
      </h1>

      <p className="description-terms">
        Thank you for choosing Blueberry Travel and our websites. By making
        reservations through them, it is deemed that you agree with their terms
        of usage and procedures. Please review all applicable clauses below to
        fully comprehend and appreciate what conditions may affect your trip:
      </p>

      <h5 className="sub-heading-terms">1. User Consent</h5>
      <p className="content-terms">
        By filling out the lead form, users agree to the terms outlined in this
        document. Users consent to providing accurate and truthful information.
      </p>

      <h5 className="sub-heading-terms">2. Itinerary Amendments</h5>
      <p className="content-terms">
        Your itinerary may be subject to amendment due to local/weather
        conditions, airline schedules, or any other factors beyond our control.
        Blueberry Travel will offer suitable alternatives of similar value and
        availability based on these considerations. Blueberry Travel reserves
        the right to make minor amendments without compensation at any time; no
        such compensation shall apply in case of force majeure incidents such as
        flooding or earthquakes.
      </p>

      <h5 className="sub-heading-terms">3. Travel Documents</h5>
      <p className="content-terms">
        Every traveler is solely responsible for making sure that they possess
        all essential travel documents, such as their passports, visas, and any
        relevant health certificates; no refund will be offered in case these
        important papers go missing or are lost during travel.
      </p>

      <h5 className="sub-heading-terms">4. Website Usage Regulations / No Show Policy and Refund Processing</h5>
      <p className="content-terms">
        All content found on this website, such as logos and images, as well as
        information regarding travel services and pricing details, are owned by
        Blueberry Travel, and you agree not to exploit its contents for
        non-personal, commercial, or illegitimate uses.
      </p>

      <h5 className="sub-heading-terms">5. Delivery & Transport Coverage</h5>
      <p className="content-terms">
        Blueberry Travel will not deal with or provide services or products to
        OFAC-sanctioned countries following UAE laws.
      </p>

      <h5 className="sub-heading-terms">6. Legal Framework and Jurisdictional Issues</h5>
      <p className="content-terms">
        Any purchase, dispute, or claim related to this website shall be
        governed and determined following UAE laws.
      </p>

      <h5 className="sub-heading-terms">7. Changes to Terms and Services</h5>
      <p className="content-terms">
        The company reserves the right to amend the terms without prior notice.
        Users will be notified of significant changes through email or updates
        on the website.
      </p>
    </div>
    <Footer />
    </>
  );
};

export default TermsAndConditions;
